import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-review-entry',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-entry.component.html',
  styleUrls: ['./review-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewEntryComponent {
  @Input() label: string = '';
  @Input() value: string | number = '';
}
